import { render, staticRenderFns } from "./SearchOrganizationsResult.vue?vue&type=template&id=d38f8f5c&scoped=true&"
import script from "./SearchOrganizationsResult.vue?vue&type=script&lang=ts&"
export * from "./SearchOrganizationsResult.vue?vue&type=script&lang=ts&"
import style0 from "./SearchOrganizationsResult.vue?vue&type=style&index=0&id=d38f8f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38f8f5c",
  null
  
)

export default component.exports